export const AUTH = "AUTH/auth";
export const ATTEMP = "AUTH/attemp";
export const LOGIN = "AUTH/login";
export const LOGOUT = "AUTH/logout";
export const USER_PROFILE = "AUTH/user_profile";
export const REGISTER = "AUTH/register";
export const GET_PROFILE = "AUTH/get_profile";
export const GET_RPTAX_API = "AUTH/get_rptax";
export const UPDATE_PROFILE = "AUTH/update_profile";
export const UPDATE_PASSWORD = "AUTH/update_password";
export const ACTIVATE_ACCOUNT = "AUTH/activate_account";
export const FORGOT_PASSWORD = "AUTH/forgot_password";
export const RESET_PASSWORD = "AUTH/reset_password";
export const RESEND_OTP = "AUTH/resend_otp";
export const FORGOT_PASSWORD_VALIDATE = "AUTH/forgot_password_validate";
export const RESEND_FORGOT_PASSWORD_VALIDATE = "AUTH/resend_forgot_password_validate";
export const RESET_PASSWORD_OTP = "AUTH/reset_password_otp";
export const UPDATE_PIN = 'CITIZEN/update_pin';
export const CHANGE_PASSWORD = 'AUTH/change_password';

export const isFromSso = () => {
  return sessionStorage.getItem('is_sso') === '1'
}

export const E_VERIFY_USER = "AUTH/E_VERIFY_USER";

export const TAB_NO = 0;

export const PAGE_TAB = 'PAGE_TAB/page_tab';